import React from "react";

const ExpenseSVG = ({ activeSvgColor }) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5003 10.1667C11.5837 10.1667 10.0003 8.58333 10.0003 6.66667C10.0003 4.75 11.5837 3.16667 13.5003 3.16667H15.917C15.7503 1.41667 14.2503 0 12.417 0H4.08366C2.25033 0 0.666992 1.5 0.666992 3.41667V9.91667C0.666992 11.8333 2.25033 13.3333 4.16699 13.3333H12.5003C14.3337 13.3333 15.8337 11.9167 16.0003 10.1667H13.5003Z"
        fill={activeSvgColor}
      />
      <path
        d="M16.167 4.83398H13.5003C12.5003 4.83398 11.667 5.66732 11.667 6.66732C11.667 7.66732 12.5003 8.50065 13.5003 8.50065H16.167C16.8337 8.50065 17.3337 8.00065 17.3337 7.33398V6.00065C17.3337 5.33398 16.8337 4.83398 16.167 4.83398Z"
        fill={activeSvgColor}
      />
    </svg>
  );
};

export default ExpenseSVG;
